import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ImportantModal } from '../ImportantModal';
import { ModalHeader, ModalBody, ModalFooter } from '../Modal';
import { Heading } from '@instructure/ui-heading';
import { Button, CloseButton } from '@instructure/ui-buttons';
import t from '@instructure/quiz-i18n/format-message';
export var SimpleModal = /*#__PURE__*/function (_Component) {
  function SimpleModal() {
    _classCallCheck(this, SimpleModal);
    return _callSuper(this, SimpleModal, arguments);
  }
  _inherits(SimpleModal, _Component);
  return _createClass(SimpleModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        isModalOpen = _this$props.isModalOpen,
        onModalDismiss = _this$props.onModalDismiss,
        onModalClose = _this$props.onModalClose,
        showCloseButton = _this$props.showCloseButton,
        size = _this$props.size,
        footerContent = _this$props.footerContent,
        children = _this$props.children,
        title = _this$props.title;
      return /*#__PURE__*/React.createElement(ImportantModal, {
        open: isModalOpen,
        onDismiss: onModalDismiss,
        onClose: onModalClose,
        transition: "fade",
        size: size,
        label: label
      }, /*#__PURE__*/React.createElement(ModalHeader, null, showCloseButton && /*#__PURE__*/React.createElement(CloseButton, {
        placement: "end",
        offset: "medium",
        onClick: onModalDismiss,
        screenReaderLabel: t('Close')
      }), title && /*#__PURE__*/React.createElement(Heading, null, title)), /*#__PURE__*/React.createElement(ModalBody, null, children), /*#__PURE__*/React.createElement(ModalFooter, null, footerContent || /*#__PURE__*/React.createElement(Button, {
        onClick: onModalDismiss
      }, t('Close'))));
    }
  }]);
}(Component);
_defineProperty(SimpleModal, "propTypes", {
  children: PropTypes.node,
  footerContent: PropTypes.node,
  title: PropTypes.node,
  label: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool,
  onModalDismiss: PropTypes.func,
  showCloseButton: PropTypes.bool,
  onModalClose: PropTypes.func,
  size: PropTypes.string
});
_defineProperty(SimpleModal, "defaultProps", {
  children: null,
  footerContent: null,
  title: null,
  isModalOpen: false,
  showCloseButton: true,
  onModalDismiss: Function.prototype,
  onModalClose: Function.prototype,
  size: 'auto'
});
export default SimpleModal;